import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum AddTradingAccountFormErrorStatesEnum {
    CreateTradingClientFailed = ErrorStateScheduleEnum.AddTradingAccountFormStatesStartIndex,
    CreateTradingGroupFailed,
    CreateTradingAccountFailed,
    GetSelectedTradingGroupFailed
}
